"use strict";

var _classCallCheck = require("C:\\Users\\tex\\source\\repos\\DataFund\\dr-editor-sample\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Users\\tex\\source\\repos\\DataFund\\dr-editor-sample\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _web3Utils = require("web3-utils");

var _secp256k = _interopRequireDefault(require("secp256k1"));

var _FDSSwarm = _interopRequireDefault(require("./FDS-Swarm"));

var _FDSTrace = _interopRequireDefault(require("./FDS-Trace"));

var _axios = require("axios");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
} // Copyright 2019 The FairDataSociety Authors
// This file is part of the FairDataSociety library.
//
// The FairDataSociety library is free software: you can redistribute it and/or modify
// it under the terms of the GNU Lesser General Public License as published by
// the Free Software Foundation, either version 3 of the License, or
// (at your option) any later version.
//
// The FairDataSociety library is distributed in the hope that it will be useful,
// but WITHOUT ANY WARRANTY; without even the implied warranty of
// MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
// GNU Lesser General Public License for more details.
//
// You should have received a copy of the GNU Lesser General Public License
// along with the FairDataSociety library. If not, see <http://www.gnu.org/licenses/>.
// interaction with swarm feeds


var SwarmFeeds =
/*#__PURE__*/
function () {
  /**
   * Creates a new instance of SwarmFeeds
   * @constructor
   * @param {string} swarmNode - The url of the Swarm gateway endpoint.
   */
  function SwarmFeeds(swarmNode) {
    _classCallCheck(this, SwarmFeeds);

    if (typeof swarmNode !== 'string') {
      throw new Error('You must provide a Swarm gateway endpoint.');
    }

    this.swarmNode = swarmNode;
  }
  /**
   * Retrieves the Swarm hash associated with pointer of a topic
   * @get
   * @param {string} address - 0x prefixed Ethereum address of the owner of the feed.
   * @param {string} topicName - utf8 string of the topic.
   * @returns {promise} promise which resolves rejects with error based on ajax request outcome.      
   */


  _createClass(SwarmFeeds, [{
    key: "getHex",
    value: function getHex(address, topicName) {
      return this.get(address, topicName, 'arraybuffer').then(function (response) {
        return (0, _web3Utils.bytesToHex)(response);
      });
    }
    /**
     * Retrieves the Swarm hash associated with pointer of a topic
     * @get
     * @param {string} address - 0x prefixed Ethereum address of the owner of the feed.
     * @param {string} topicName - utf8 string of the topic.
     * @param {any} responseType response type
     * @returns {promise} promise which resolves rejects with error based on ajax request outcome.
     */

  }, {
    key: "get",
    value: function get(address, topicName) {
      var _this = this;

      var responseType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'text';
      return this.getResource(topicName, address).then(function (hash) {
        return _this.sendRequest("/bzz-raw:/".concat(hash, "/"), 'GET', responseType);
      });
    }
    /**
     * Retrieves the Swarm hash associated with pointer of a topic
     * @set
     * @param {string} address - 0x prefixed Ethereum address of the owner of the feed.
     * @param {string} topicName - utf8 string of the topic.
     * @param {string} privateKey - private key of the owner of the feed.
     * @param {string} data - a text string of data which will be uploaded and the resultant hash set as the pointer location.
     * @returns {promise} promise which resolves rejects with error based on ajax request outcome.   
     */

  }, {
    key: "set",
    value: function set(address, topicName, privateKey, data) {
      var _this2 = this;

      return this.sendRequest('/bzz-raw:/', 'POST', 'text', (0, _web3Utils.toHex)(data)).then(function (hash) {
        return _this2.updateResource(topicName, address, privateKey, (0, _web3Utils.toHex)(hash));
      });
    }
  }, {
    key: "pin",
    value: function pin(hash) {
      return this.sendRequest('/bzz-pin:/' + hash + '/?raw=true', 'POST', 'text', "", function () {}, 0, true);
    }
    /**
     * Retrieves the pointer of a topic
     * @getResource
     * @param {string} topicName - utf8 string of the topic.
     * @param {string} address - 0x prefixed Ethereum address of the owner of the feed.
     * @returns {promise} promise which resolves rejects with error based on ajax request outcome.      
     */

  }, {
    key: "getResource",
    value: function getResource(topicName, address) {
      var topic = (0, _web3Utils.padRight)((0, _web3Utils.toHex)(topicName), 64, '0');
      return this.sendRequest("/bzz-feed:/?topic=".concat(topic, "&user=").concat(address), 'GET');
    }
    /**
     * Retrieves the meta information of a topic
     * @getMeta
     * @param {string} topicName - utf8 string of the topic.
     * @param {string} address - 0x prefixed Ethereum address of the owner of the feed.
     * @returns {promise} promise which resolves rejects with error based on ajax request outcome.      
     */

  }, {
    key: "getMeta",
    value: function getMeta(topicName, address) {
      var topic = (0, _web3Utils.padRight)((0, _web3Utils.toHex)(topicName), 64, '0');
      return this.sendRequest("/bzz-feed:/?topic=".concat(topic, "&user=").concat(address, "&meta=1"), 'GET', 'text');
    }
    /**
     * Updates the content of the feed
     * @updateResource
     * @param {string} topicName - utf8 string of the topic.
     * @param {string} address - 0x prefixed Ethereum address of the owner of the feed.
     * @param {string} privateKey - private key of the owner of the feed.
     * @param {string} state - hex encoded state data.
     * @returns {promise} promise which resolves with ? and rejects with error based on ajax request outcome.   
     */

  }, {
    key: "updateResource",
    value: function updateResource(topicName, address, privateKey, state) {
      var _this3 = this;

      var pin = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
      var data = (0, _web3Utils.padLeft)(state, 2, '0');
      var topic = (0, _web3Utils.padRight)((0, _web3Utils.toHex)(topicName), 64, '0');
      return this.getMeta(topicName, address).then(function (response) {
        var metaResponse = JSON.parse(response);

        var digest = _this3.feedUpdateDigest(metaResponse, data);

        var signature = _this3.signData(digest, privateKey);

        return _this3.sendRequest("/bzz-feed:/?topic=".concat(metaResponse.feed.topic, "&user=").concat(metaResponse.feed.user, "&level=").concat(metaResponse.epoch.level, "&time=").concat(metaResponse.epoch.time, "&signature=").concat(signature), 'POST', 'text', data).then(function (response) {
          var hash = response.substr(1).substr(0, 64);

          var nr = _this3.pin(hash);

          return response;
        });
      });
    }
    /**
     * Performs XMLHTTPRequests
     * @sendRequest
     * @param {string} url - url of the request.
     * @param {string} requestType - request type, must be POST or GET.
     * @param {string} responseType - expected response type, must be text or arraybuffer
     * @param {arraybuffer} data - binary data contained in ArrayBuffer.
     * @returns {promise} promise which resolves with data or rejects with error based on ajax request outcome.   
     */

  }, {
    key: "sendRequest",
    value: function sendRequest(url, requestType, responseType) {
      var data = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      var pinHeader = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

      _FDSTrace.default.time('sendRequest//SwarmFeeds');

      if (data) {
        data = Buffer.from((0, _web3Utils.hexToBytes)(data));
      }

      var headers = {
        'Accept': 'application/octet-stream'
      };

      if (pinHeader) {
        headers['x-swarm-pin'] = true;
      }

      return (0, _axios.request)({
        responseType: responseType,
        url: "".concat(this.swarmNode).concat(url),
        method: requestType,
        headers: headers,
        data: data,
        transformResponse: [function (data) {
          // Do whatever you want to transform the data
          if (responseType === 'arraybuffer') {
            return Buffer.from(data);
          } else {
            return data;
          }
        }]
      }).then(function (response) {
        _FDSTrace.default.timeEnd('sendRequest//SwarmFeeds');

        _FDSTrace.default.log(url, requestType);

        return response.data;
      });
    }
    /**
     * Signs data using secp256k1 curve
     * @signData
     * @param {string} data - hex encoded data.
     * @param {string} privateKey key to sign
     * @returns {string} hex encoded signature.
     */

  }, {
    key: "signData",
    value: function signData(data, privateKey) {
      var sigObj = _secp256k.default.sign(Buffer.from((0, _web3Utils.hexToBytes)(data)), Buffer.from((0, _web3Utils.hexToBytes)(privateKey)));

      return "0x".concat(sigObj.signature.toString('hex'), "0").concat(sigObj.recovery.toString());
    }
    /**
     * Creates the data to sign for the feed update digest
     * @feedUpdateDigest
     * @param {object} metaResponse - the server response from getMeta.
     * @param {string} data - hex encoded data.
     * @returns {string} sha3 hashed digest.   
     */

  }, {
    key: "feedUpdateDigest",
    value: function feedUpdateDigest(metaResponse, data) {
      var dataBytes = (0, _web3Utils.hexToBytes)(data);
      var topicBytes;
      var userBytes;
      var protocolVersion = 0;
      var topicLength = 32;
      var userLength = 20;
      var timeLength = 7;
      var levelLength = 1;
      var headerLength = 8;
      var updateMinLength = topicLength + userLength + timeLength + levelLength + headerLength;
      protocolVersion = metaResponse.protocolVersion;

      try {
        topicBytes = (0, _web3Utils.hexToBytes)(metaResponse.feed.topic);
      } catch (err) {
        return undefined;
      }

      try {
        userBytes = (0, _web3Utils.hexToBytes)(metaResponse.feed.user);
      } catch (err) {
        return undefined;
      }

      var buf = new ArrayBuffer(updateMinLength + dataBytes.length);
      var view = new DataView(buf);
      var cursor = 0;
      view.setUint8(cursor, protocolVersion); // first byte is protocol version.

      cursor += headerLength; // leave the next 7 bytes (padding) set to zero

      topicBytes.forEach(function (v) {
        view.setUint8(cursor, v);
        cursor++;
      });
      userBytes.forEach(function (v) {
        view.setUint8(cursor, v);
        cursor++;
      }); // time is little-endian

      view.setUint32(cursor, metaResponse.epoch.time, true);
      cursor += 7;
      view.setUint8(cursor, metaResponse.epoch.level);
      cursor++;
      dataBytes.forEach(function (v) {
        view.setUint8(cursor, v);
        cursor++;
      });
      return (0, _web3Utils.sha3)((0, _web3Utils.padLeft)((0, _web3Utils.bytesToHex)(new Uint8Array(buf)), 264));
    }
    /**
     * Converts data from hex string to ArrayBuffer
     * @signData
     * @param {string} data - hex encoded data.
     * @returns {arraybuffer} data - array buffer.
     */

  }, {
    key: "dataToBuffer",
    value: function dataToBuffer(data) {
      return Buffer.from(data, "hex");
      var dataBytes = (0, _web3Utils.hexToBytes)(data);
      var buf = new ArrayBuffer(dataBytes.length);
      var dataView = new DataView(buf);

      for (var i = 0; i < dataBytes.length; i++) {
        dataView.setUint8(i, dataBytes[i]);
      }

      return buf;
    }
  }]);

  return SwarmFeeds;
}();

var _default = SwarmFeeds;
exports.default = _default;
module.exports = exports.default;